import React from 'react';
import PropTypes from 'prop-types';
import './SharedBadge.css';

const ROLE_TEXT = { editor: 'an editor', viewer: 'a viewer' };

/** "Shared" marker for a project someone else shared with the caller (docs/project-sharing.md). */
export default function SharedBadge({ role }) {
  const title = ROLE_TEXT[role] ? `Shared with you as ${ROLE_TEXT[role]}` : 'Shared with you';
  return <span className="shared-badge" title={title}>Shared</span>;
}

SharedBadge.propTypes = { role: PropTypes.string };
